import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {
	fromIsoToDate,
	getLocalizedDateFormat,
} from 'library/formatters/DateFormatter';

import { ReleaseNoteListProps } from './types';

const ReleaseNoteHeader = ({
	releaseNote: { date, title },
}: ReleaseNoteListProps) => (
	<Box
		alignItems="center"
		display="grid"
		gridTemplateColumns={'1fr 2fr 1fr'}
		gap={2}
		width="100%">
		<Typography variant="body1">
			{getLocalizedDateFormat(fromIsoToDate(date))}
		</Typography>
		<Typography variant="body1">{title}</Typography>
	</Box>
);

export default ReleaseNoteHeader;
